var styles = [".fixed[_ngcontent-%COMP%]{position:fixed}"];
export { styles as styles };
